import { maybe } from "../core/utils";
import { useEffect, useState } from "react";

export const mapNodes = nodes => nodes.map(({ node }) => node);

export const pageInfo = `
  pageInfo {
    endCursor
    hasNextPage
  }
`;

export const buildEdgesQuery = ({ entity, options, fragments, model }) => {
  const graphqlOptions = Object.entries(options)
    .map(([key, value]) => `${key}: ${value}`)
    .join(",");
  console.warn(`${entity}(${graphqlOptions}) `)
  return `
      ${fragments}
      query {
        wp {
          items: ${entity}(${graphqlOptions}) {
            nodes {
              ${model}
            }
            ${pageInfo}
          }
        }
      }
  `;
};

export const loadEntireList = async ({
  fragments = ``,
  options = { first: 10 },
  model = `id`,
  entity,
  graphql,
}: {
  fragments?: string;
  options?: {
    [key: string]: string | number | object;
  };
  model: string;
  entity: string;
  graphql: any;
}) => {
  const query = buildEdgesQuery({ entity, options, fragments, model });
  const { data, errors } = await graphql(query);
  if (!maybe(() => !!data.wp.items.pageInfo)) {
    console.error("Houston, mamy problem z pobieraniem listy!");
    console.error(entity, query, '-------------', errors);
  }
  // console.warn(entity, options)
  const {
    wp: {
      items: { pageInfo, nodes },
    },
  } = data;

  if (pageInfo.hasNextPage) {
    // @TODO: temporary hotfix
    return [
      ...nodes,
      ...(await loadEntireList({
        entity,
        fragments,
        graphql,
        model,
        options: {
          ...options,
          after: `"${pageInfo.endCursor}"`,
        },
      })),
    ];
  }
  return nodes;
};

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
  );
  return debouncedValue;
}
